import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-devices-search-cards',
  templateUrl: './devices-search-cards.component.html',
  styleUrls: ['./devices-search-cards.component.scss']
})
export class DevicesSearchCardsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
